import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { WorkspaceLifecycle } from 'app/app.types';

@Injectable({ providedIn: 'root' })
export class WorkspaceLifecycleService {
    private readonly _readonly$ = new BehaviorSubject<boolean>(false);
    readonly readonly$ = this._readonly$.asObservable();

    private _blocked = false;
    private _blockedMessage = '';

    get isReadonly(): boolean {
        return this._readonly$.value;
    }

    get isBlocked(): boolean {
        return this._blocked;
    }

    get blockedMessage(): string {
        return this._blockedMessage;
    }

    applyLifecycle(lifecycle: WorkspaceLifecycle | null): void {
        this._blocked = !!lifecycle?.blocked;
        this._blockedMessage = lifecycle?.banner?.message ?? lifecycle?.status ?? 'This workspace is unavailable.';
        this._readonly$.next(!!lifecycle?.readonly && !this._blocked);
    }

    notifyBlocked(message: string, lifecycle?: WorkspaceLifecycle | null): void {
        this._blocked = true;
        this._blockedMessage = message;
        if (lifecycle) {
            this.applyLifecycle(lifecycle);
        }
    }

    notifyReadonly(message: string): void {
        this._readonly$.next(true);
    }

    clearForcedFlags(): void {
        this._blocked = false;
        this._blockedMessage = '';
    }
}
